import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import {error_message} from './error';

axios.defaults.withCredentials= true;
axios.defaults.baseURL = '/vv/';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.defaults.timeout = 20000

axios.interceptors.request.use(
    config => {
        if (localStorage.dmjAuthor) {
            config.headers['X-TOKEN'] = localStorage.dmjAuthor
        }
        if (config.method === 'post') {
            // config.data = qs.stringify(config.data)
            // config.params = undefined
        }
        // config.params = easEncrypt(qs.stringify(config.params), key, key.substring(0, 16))
        return config
    },
    error => Promise.resolve(error.response || error)
)

axios.interceptors.response.use(
    response => {
        if (response.data.status == 0) {

        } else if (response.data.status == 72) {
            window.logout()
        }
        return Promise.resolve(response)
    },
    error => {
        if (error.response.status == 401 && error.response.statusText == 'Unauthorized') {
            Message.error('您需要登录')
            localStorage.removeItem('dmjAuthor')

            return
        }
        return Promise.resolve(error.response || error)
    }
)

export const fetch = (url, data = {}, method = 'post') => {
    return new Promise((resolve, reject) => {
        axios({
            url,
            data,
            method
        }).then(res => {
            // console.log({res});
            if (res.data.status && res.data.status == 72) {
                Message.error('您需要登录！')
                window.openLogin()
                // resolve(res.data)
            }
            if (res.data.status && res.data.err) {
                Message.error(res.data.err)
            } else if (res.data.status && error_message[res.data.status]) {
                Message.error(error_message[res.data.status])
            }
            resolve(res.data)
        })
    })
}

Vue.prototype.$fetch = fetch
